import { Pagination } from "rsuite";
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { httpRequest } from "utils/httpRequest";
import { toast } from "react-toastify";
import CircleLoader from "components/loader/CircleLoader";
import { useLoader } from "components/loader/useLoader";

export default function StatePage() {
  const [stateList, setStateList] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modal, setModal] = useState(false);

  const [selectedStateName, setSelectedStateName] = useState(null);
  const [selectedStateId, setSelectedStateId] = useState(null);
  let navigate = useNavigate();

  const { loading, startLoading, stopLoading } = useLoader();

  const validationSchema = Yup.object({
    state: Yup.string()
      .trim()
      .required("State name is required")
      .min(2, "State name must be at least 2 characters"),
  });

  const formik = useFormik({
    initialValues: {
      state: "", // ✅ default value
    },
    validationSchema,

    onSubmit: async (values, { resetForm }) => {
      console.log("Form submitted with:", values);

      try {
        const response = await httpRequest(
          "statecity/add-state",
          "POST",
          {
            name: values.state,
          },
          {},
          true,
          true
        );

        if (response.code === 200) {
          toast.success("State added successfully.");
          resetForm();
          setModal(!modal);
          getStatesList();
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  const handlePageChange = (page) => {
    setActivePage(page);
    getStatesList(page);
  };

  function handleopencitypage(stateId) {
    navigate(`/admin/city/${stateId}`);
  }

  const toggle = () => setModal(!modal);

  const handleDelete = async (id) => {
    try {
      const response = await httpRequest(
        `statecity/delete-state/${id}`,
        "DELETE",
        {},
        {},
        true,
        true
      );
      if (response?.code === 200) {
        toast.success("State deleted successfully");
        getStatesList();
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    getStatesList();
  }, []);

  const getStatesList = async (page = activePage) => {
    startLoading();
    try {
      const response = await httpRequest(
        "statecity/get-state",
        "GET",
        {},
        {
          offset: (page - 1) * limit,
          limit: limit,
        },
        true,
        false
      );

      if (response.code === 200) {
        setStateList(response.data);
        setTotal(response?.count);
      }
    } catch (error) {
      console.error("Upload error:", error);
    } finally {
      stopLoading();
    }
  };

  return (
    <>
      {loading ? (
        <CircleLoader />
      ) : (
        <div className="container-fluid py-4 mt-5">
          <div className="row">
            <div className="col">
              <div className="card shadow">
                {/* Card Header */}
                <div className="card-header border-0 d-flex justify-content-end">
                  <h3 className="mb-0 mr-auto">State</h3>
                  {/* <Button color="primary" size="sm" onClick={handleNavigationOnAddArticle}> */}
                  <Button color="primary" size="sm" onClick={toggle}>
                    Add State
                  </Button>
                </div>

                {/* Table */}
                <div className="table-responsive">
                  <table className="table align-items-center table-flush">
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">S.No</th>
                        <th scope="col">State</th>

                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stateList &&
                        stateList.length > 0 &&
                        stateList.map((item, index) => (
                          <tr key={item._id}>
                            <td>
                              <span className="mb-0 text-sm font-weight-bold">
                                {(activePage - 1) * limit + index + 1}
                              </span>
                            </td>
                            <td>
                              <span className="mb-0 text-sm font-weight-bold">
                                {item?.name}
                              </span>
                            </td>

                            <td>
                              {/* Add City icon   */}
                              <button
                                className="btn  btn-sm"
                                onClick={() => handleopencitypage(item?._id)}
                                title="View"
                              >
                                <i
                                  className="fas fa-eye text-primary me-2"
                                  title="View"
                                ></i>
                              </button>

                              {/* Delete icon  */}
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => {handleDelete(item?._id)}}
                                title="Delete"
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>

                {/* Modal */}
                <Modal isOpen={modal} toggle={toggle}>
                  <ModalHeader toggle={toggle}>Add State</ModalHeader>
                  <ModalBody>
                    <form onSubmit={formik.handleSubmit}>
                      <FormGroup>
                        <Label for="addstate">State</Label>
                        <Input
                          id="addstate"
                          name="state"
                          placeholder="Enter State"
                          type="text"
                          value={formik.values.state}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          invalid={
                            formik.touched.state && !!formik.errors.state
                          }
                        />
                        {formik.touched.state && formik.errors.state && (
                          <div className="text-danger">
                            {formik.errors.state}
                          </div>
                        )}
                      </FormGroup>

                      <ModalFooter>
                        <Button color="primary">Add</Button>{" "}
                        <Button color="secondary" onClick={toggle}>
                          Cancel
                        </Button>
                      </ModalFooter>
                    </form>
                  </ModalBody>
                </Modal>

                {/* Delete Modal  */}

                {/* Card Footer with Pagination */}
                <div className="card-footer py-4">
                  <div className="d-flex justify-content-end">
                    <Pagination
                      size="sm"
                      total={total} // backend-provided total count
                      limit={limit} // we control this (useState)
                      activePage={activePage}
                      onChangePage={handlePageChange}
                      maxButtons={5}
                      prev
                      next
                      last
                      first
                      ellipsis
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
